import { TYPE_LABEL, PRICE_LABEL } from './config.js'
import { getPlaces, neighbourhoods, quartierOf, matchesSearch, isSaved, savedCount } from './data.js'

const state = {
  tab: 'all', // 'all' | 'top10' | 'restaurant' | 'bar' | 'cafe' | 'bakery' | 'saved'
  quartier: '',
  prices: new Set(),
  search: '',
}

let onChange = () => {}

export function getState() { return state }
export function setTab(tab) { state.tab = tab }

export function initFilters(changeCb) {
  onChange = changeCb
  buildTabs()
  buildQuartiers()
  buildPrices()

  const search = document.getElementById('search')
  search.addEventListener('input', () => { state.search = search.value.trim(); onChange(false) })

  document.getElementById('clear').onclick = () => {
    state.tab = 'all'; state.quartier = ''; state.prices.clear(); state.search = ''
    search.value = ''
    refreshControls()
    onChange(true)
  }
}

function buildTabs() {
  const all = getPlaces()
  const present = new Set(all.map((p) => p.type))
  const tabs = [['all', 'All']]
  if (all.some((p) => p.free)) tabs.push(['top10', '★ Top 10'])
  for (const t of ['restaurant', 'bar', 'cafe', 'bakery', 'shop']) {
    if (present.has(t)) tabs.push([t, TYPE_LABEL[t]])
  }
  tabs.push(['saved', '♥ Saved'])

  const el = document.getElementById('tabs')
  el.innerHTML = ''
  for (const [key, label] of tabs) {
    const b = document.createElement('button')
    b.dataset.tab = key
    b.innerHTML = `${label} <span class="n" data-count="${key}"></span>`
    b.onclick = () => { state.tab = key; refreshControls(); onChange(true) }
    el.appendChild(b)
  }
}

function buildQuartiers() {
  const el = document.getElementById('quartiers')
  el.innerHTML = ''
  const sel = document.createElement('select')
  sel.id = 'area-select'
  sel.className = 'area-select'
  sel.setAttribute('aria-label', 'Filter by area')
  const opt0 = document.createElement('option')
  opt0.value = ''
  opt0.textContent = 'All areas'
  sel.appendChild(opt0)
  for (const q of neighbourhoods()) {
    const o = document.createElement('option')
    o.value = q
    o.textContent = q
    sel.appendChild(o)
  }
  sel.onchange = () => { state.quartier = sel.value; refreshControls(); onChange(true) }
  el.appendChild(sel)
}

function buildPrices() {
  const el = document.getElementById('prices')
  el.innerHTML = ''
  for (const p of [1, 2, 3, 4]) {
    const b = document.createElement('button')
    b.className = 'chip'
    b.dataset.price = p
    b.textContent = PRICE_LABEL[p]
    b.onclick = () => {
      state.prices.has(p) ? state.prices.delete(p) : state.prices.add(p)
      refreshControls(); onChange(true)
    }
    el.appendChild(b)
  }
}

// Reflect state into the controls + counts + clear-button visibility.
export function refreshControls() {
  document.querySelectorAll('#tabs button').forEach((b) =>
    b.classList.toggle('active', b.dataset.tab === state.tab))
  const areaSel = document.getElementById('area-select')
  if (areaSel) areaSel.value = state.quartier
  document.querySelectorAll('#prices .chip').forEach((b) =>
    b.classList.toggle('active', state.prices.has(Number(b.dataset.price))))

  const all = getPlaces()
  const count = (key) =>
    key === 'all' ? all.length
      : key === 'saved' ? savedCount()
        : key === 'top10' ? all.filter((p) => p.free).length
          : all.filter((p) => p.type === key).length
  document.querySelectorAll('#tabs .n').forEach((n) => {
    n.textContent = count(n.dataset.count)
  })

  const active = state.tab !== 'all' || state.quartier || state.prices.size || state.search
  document.getElementById('clear').hidden = !active
}

export function applyFilters(places) {
  return places.filter((p) => {
    if (state.tab === 'saved') { if (!isSaved(p.id)) return false }
    else if (state.tab === 'top10') { if (!p.free) return false }
    else if (state.tab !== 'all') { if (p.type !== state.tab) return false }
    if (state.quartier && quartierOf(p) !== state.quartier) return false
    if (state.prices.size && !state.prices.has(p.price)) return false
    if (!matchesSearch(p, state.search)) return false
    return true
  })
}

export function activeQuartierLabel() {
  if (state.quartier) return state.quartier
  if (state.tab === 'top10') return 'my Top 10'
  return (state.tab !== 'all' && state.tab !== 'saved') ? TYPE_LABEL[state.tab] : ''
}
